module.exports = __webpack_public_path__ + "img/house.33ae616c.svg";